export const endpoints = {
  code: (codetableId: number) => `optionsCollection/${codetableId}/code`,
  substanceUom: 'code/uom/options'
};
